import React, { Component } from 'react';
import {
    MessageBar,
    MessageBarType,
} from 'office-ui-fabric-react/lib/MessageBar';
import {Label} from 'office-ui-fabric-react/lib/Label';
import * as _ from 'lodash';
import { ILocationsAndEquipmentsProps, ILocationsAndEquipmentsState } from './interfaces/ILocationsAndEquipments';
import { IActivityEquipment, IActivityLocation } from './interfaces/IActivityForm';
import AppConfig from '../../Constants';
import { Icon, Link } from '@fluentui/react';

export default class LocationsAndEquipments extends Component<ILocationsAndEquipmentsProps,ILocationsAndEquipmentsState> {
    constructor(props:ILocationsAndEquipmentsProps) {
        super(props);
        this.state ={
            Equipments:[],
            Locations:[],
            selectedLocations:[],
            selectedEquipments:[],
            locationEquipKey:'1'
        }
    }
    componentDidMount() {
        const {Equipments,Locations,locationEquipKey,
            selectedLocations,
            selectedEquipments} = this.props;
        this.setState({
            Equipments:Equipments,
            Locations:Locations,
            selectedLocations:selectedLocations,
            locationEquipKey:locationEquipKey,
            selectedEquipments:selectedEquipments
        });
    }
    componentDidUpdate(prevProps:ILocationsAndEquipmentsProps, prevState:ILocationsAndEquipmentsState) {
        const {locationEquipKey,Equipments,Locations,
            selectedLocations,
            selectedEquipments} = this.props;
        if(locationEquipKey !=prevProps.locationEquipKey){
            this.setState({
                locationEquipKey:locationEquipKey,
                Equipments:Equipments,
                Locations:Locations,
                selectedLocations:selectedLocations,
                selectedEquipments:selectedEquipments
            });
        }
    }
    getOptionsSelected =(options:any)=>{
        var locValues:number[] = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                locValues.push(parseInt(options[i].id));
            }
        }
        return locValues ;
    }
    handleEquipmentChange = (ev:any) => {
        let currTarget:any = ev.target.id;
        var options:any = ev.target.options;
        var values:number[]  = this.getOptionsSelected(options);
        this.setState({
            selectedEquipments: values,
        });
        this.props.handleEquipmentSelectionChange(values,currTarget);
    }
    handleLocationDropDownChange = (ev:any) => {
        let currTarget:any = ev.target.id;
        var options:any = ev.target.options;
        var equipmentsSelected:any = [];
        var locValues:number[]  = this.getOptionsSelected(options);
        const {selectedEquipments, Equipments} = this.state;
        if (selectedEquipments.length > 0) {
            var locSpecificEquips = [];
            locSpecificEquips = _.filter(Equipments, equipment => {
                if (locValues.indexOf(equipment.LocationId) !== -1 && equipment.EquipmentId) {
                    return equipment.EquipmentId;
                }
            });
            var locEquipmentIds:number[] = _.map(locSpecificEquips,'EquipmentId');
            equipmentsSelected = _.reject(selectedEquipments,(equipment) => {
                    if (locEquipmentIds.indexOf(equipment) === -1) 
                    {
                        return true;
                    }
            });
            this.setState({
                selectedLocations: locValues,
                selectedEquipments: equipmentsSelected,
            });
        } 
        else {
            this.setState({
                selectedLocations: locValues,
                selectedEquipments:[]
            });
        }
        this.props.handleLocationSelectionChange(locValues,equipmentsSelected);
    }
    renderEquipments = (equipments:IActivityEquipment[], selectedLocations:number[]) => {
        if (equipments.length > 0 && selectedLocations.length) {
            const {selectedEquipments} = this.state;
            var equipmentOptionsArr:any = [];
            equipmentOptionsArr = _.filter(equipments, equipment => {
                if (selectedLocations.indexOf(equipment.LocationId) !== -1 && equipment) {
                    return equipment;
                }
            });
            let options = equipmentOptionsArr.map((equipment:IActivityEquipment, key:any) => {
                if (
                    selectedEquipments && equipment.EquipmentId &&
                    selectedEquipments.indexOf(equipment.EquipmentId) !== -1
                ) {
                    return (
                        <option
                            id={equipment.EquipmentId?.toString()}
                            value={equipment.EquipmentName}
                            selected={true}
                            key={key + equipment.EquipmentName}
                            disabled={equipment.EquipStatusId === AppConfig.ActivityForm.InactiveStatusId}>
                            {equipment.EquipmentName}
                        </option>
                    );
                } else {
                    if(equipment.EquipmentId){
                        return (
                            <option
                                id={equipment.EquipmentId?.toString()}
                                value={equipment.EquipmentName}
                                key={key + equipment.EquipmentName}
                                disabled={equipment.EquipStatusId === AppConfig.ActivityForm.InactiveStatusId}>
                                {equipment.EquipmentName}
                            </option>
                        );
                    }                    
                }
            });
            return options;
        } else {
            return (
                <option value={0} disabled={true} style={{whiteSpace:"initial",wordBreak:"break-word",opacity:"60%"}}>
                    Select Location(s) to populate related Equipment(s)
                </option>
            );
        }
    }
    renderLocations = (locations:IActivityLocation[],selectedLocations:number[]) => {
        let options:any = locations.map((location:IActivityLocation, key:any) => {
            if(selectedLocations.indexOf(location.LocationId)!==-1){
                return (
                    <option
                        id={location.LocationId?.toString()}
                        key={key + location.LocationName}
                        value={location.LocationId}
                        selected={true}>
                        {location.LocationName}
                    </option>
                );
            }
            else{
                return (
                    <option
                        id={location.LocationId?.toString()}
                        key={key + location.LocationName}
                        value={location.LocationId}
                        selected={false}>
                        {location.LocationName}
                    </option>
                );
            }
        });
        return options;
    }
    handleMultiSelectClear = (event:any) =>{
        let fieldName:any = event.target.name;
        if (fieldName  === "Location") {
            this.setState({selectedLocations: [],selectedEquipments: []});
            this.props.handleLocationSelectionChange([],[]);

        }
        if (fieldName  === "Equipment") {
            this.setState({selectedEquipments: []});
            this.props.handleEquipmentSelectionChange([],"selectedEquipments");
        }
    }
    renderErrorMsgForField(msg:string,key:any){
        return(
             <div role="alert" key={key}>
                <p className="ms-TextField-errorMessage alertMsg">
                    <span data-automation-id="error-message">{msg}</span>
                </p>
            </div>
        );
    }
    render() {
        const{errorMsgs,viewForm} =this.props;
        const {
            Equipments,
            Locations,
            locationEquipKey,
            selectedLocations,
            selectedEquipments
        } = this.state;        
        return (
            <>
                {Locations.length>0?(
                   <>
                        <div style={{width: "66%"}}>
                            <div style={{display:"flex",alignItems:"center",justifyContent:"left"}}>
                                <Label className={'requiredLabel'} title={'Use SHIFT to select a range of equipment,\nUse CTRL to select non-contiguous equipment.'}>Equipment</Label>
                                <div style={{fontSize:12}}>
                                    <Icon style={{fontSize:"14px",cursor:"pointer",verticalAlign:"middle"}} iconName={'Info'}  
                                        title={'Use SHIFT to select a range of equipment,\nUse CTRL to select non-contiguous equipment.'}/>
                                </div>
                            </div>
                            <select
                                style={{width: "100%", height: "200px",fontSize:"12px"}}
                                disabled={viewForm}
                                id="selectedLocations"
                                title={'Use SHIFT to select a range of equipment,\nUse CTRL to select non-contiguous equipment.'}
                                multiple={true}
                                required={true}
                                onChange={e => this.handleLocationDropDownChange(e)}>
                                {this.renderLocations(Locations,selectedLocations)}
                            </select>
                            <Link name={"Location"} onClick ={this.handleMultiSelectClear} style={{fontSize:"12px", color:"black!important"}}>Clear</Link>
                            {errorMsgs.selectedLocations?this.renderErrorMsgForField(errorMsgs.selectedLocations,'selectedLocationsError'):''}
                        </div>
                        {/* <div style={{width: "31%"}}>
                            <div style={{display:"flex",alignItems:"center",justifyContent:"left"}}>
                                <Label className={'requiredLabel'} title={'Use SHIFT to select a range of equipment,\nUse CTRL to select non-contiguous equipment.'}>Equipment(s)</Label>
                                <div style={{fontSize:12}}>
                                    <Icon style={{fontSize:"14px",cursor:"pointer",verticalAlign:"middle"}} iconName={'Info'}  
                                        title={'Use SHIFT to select a range of equipment,\nUse CTRL to select non-contiguous equipment.'}/>
                                </div>
                            </div>
                            <select key={locationEquipKey}
                                style={{width: "100%", height: "200px",fontSize:"12px"}}
                                disabled={viewForm}
                                id="selectedEquipments"
                                title={'Use SHIFT to select a range of equipment,\nUse CTRL to select non-contiguous equipment.'}
                                multiple
                                onChange={e => this.handleEquipmentChange(e)}>
                                {this.renderEquipments(Equipments,selectedLocations)}
                            </select>
                            <Link name={"Equipment"} onClick ={this.handleMultiSelectClear} style={{fontSize:"12px", color:"black!important"}}>Clear</Link>
                        </div> */}
                    </>
                ):(
                    <MessageBar messageBarType={MessageBarType.error} className={"errorMsgInfo"}>
                        {AppConfig.ActivityForm.NoLocationEquipmentErrorMsg}
                    </MessageBar>
            )}
            </>
        );
    }
}